const axios = require("axios");

const BASE_URL = 'https://youtube-v31.p.rapidapi.com';

const options = {
    params: {   
      maxResults: '50',
      
    },
    headers: {
      // 'X-RapidAPI-Key': '6b171d6406msh390631919d65cc1p10749cjsnb1bf52e642c2',
      // 'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    //   'X-RapidAPI-Key': '2801000646mshbaae309dfcb005bp180bfajsn79798a14329a',
    // 'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    // 'X-RapidAPI-Key': '425d664fcfmsh5b57f75113e97c6p181ac4jsn70c60c250b83',
    // 'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    'X-RapidAPI-Key': 'd14d6be33fmshae6baa1d759740fp1b664bjsn2133b6b1e1f0',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    }
  };

// axios.request(options).then(function (response) {
// 	console.log(response.data);
// }).catch(function (error) {
// 	console.error(error);
// });

export const fetchDetails = async(query)=>{
    const {data} = await axios.get(`${BASE_URL}/${query}`,options);
    return data;
}